import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=3258ef3a&scoped=true"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"
import style0 from "./PendingOrders.vue?vue&type=style&index=0&id=3258ef3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258ef3a",
  null
  
)

export default component.exports